import { Component, OnInit, Input } from '@angular/core';
import { CopyrightComponent } from '../widgets/copyright/copyright.component';
import { SocialComponent } from '../widgets/social/social.component';
import { InformationComponent } from '../widgets/information/information.component';

@Component({
    selector: 'app-footer-one',
    templateUrl: './footer-one.component.html',
    styleUrls: ['./footer-one.component.scss'],
    imports: [InformationComponent, SocialComponent, CopyrightComponent]
})
export class FooterOneComponent implements OnInit {
  constructor() { }

  ngOnInit() {
  }

}
